import { Header } from "homepage/homeHeader";
import ShowAllPlans from "pages/home/components/showAllPlans";
import React from "react";

function Plans() {
  return (
    <>
      <Header />
      <section id="pricing" className="py-5 bg-body landing-pricing ">
        <div className="container ">
          <div className="text-center mb-3 pb-1 ">
            <span className="badge bg-label-primary">Pricing Plans</span>
          </div>
          <h3 className="text-center mb-1">
            <span className="position-relative fw-bold z-1">
              Maximize Your Health Savings{" "}
              <img
                src="../../assets/img/front-pages/icons/section-title-icon.png"
                alt="laptop charging"
                className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
              />
            </span>
            with ZenoSure
          </h3>
          <p className="text-center mb-4 pb-3">
            Extensive Discounts Enjoy savings of 10% to 15% on our
            <br />
            network of healthcare providers.
          </p>
        </div>
        <div className="mx-5">
          <ShowAllPlans hideHeader />
        </div>
      </section>
    </>
  );
}

export default Plans;
